import axios from "axios";
import { token } from "../../services/Apis";
import { reservations } from "../reservas/ReservasService";

export const saveReservasEspecialesService = async (data) => {
  let res = await axios.post(`${reservations}/blocks-subareas`, data, {
    headers: await token({}),
  });
  return res;
};